import { render, staticRenderFns } from "./HoldingsConcentrationArea.vue?vue&type=template&id=635bd6bb&scoped=true&"
import script from "./HoldingsConcentrationArea.vue?vue&type=script&lang=js&"
export * from "./HoldingsConcentrationArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635bd6bb",
  null
  
)

export default component.exports